export const isMobile = () => window.innerWidth < 1024;
export const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
//# sourceMappingURL=general.js.map